import { DEFAULT_LAYOUT } from '@/router/constant'
import type { RouteRecordRaw } from 'vue-router'

const SendCart: RouteRecordRaw = {
  path: '/SendCart',
  name: 'SendCart',
  component: DEFAULT_LAYOUT,
  redirect: '/SendCart/cart',

  children: [
    {
      path: 'cart',
      name: 'SendCart',
      component: () =>
        import(/** webpackChunkName "initialize" */ '@/views/SendCart/SendCart.vue'),
      meta: { title: '送信カート', requiresAuth: true },
    },
    {
      path: 'new-send-cart-edit',
      name: 'NewSendCart',
      component: () =>
        import(
          /** webpackChunkName "initialize" */ '@/views/multi-send-cart/select-page/IndexView.vue'
        ),
      meta: { title: '送信カート', requiresAuth: true },
    },
    {
      path: 'new-send-cart-confirm',
      name: 'NewSendCartConfirmation',
      component: () =>
        import(
          /** webpackChunkName "initialize" */ '@/views/multi-send-cart/confirm-page/IndexView.vue'
        ),
      meta: { title: '送信カート確認', requiresAuth: true },
    },
  ],
}

export default SendCart
